import React from 'react';
import { Link } from 'react-router-dom';
import icon1 from '../../../images/icon/da-fea_icon01.svg'
import icon2 from '../../../images/icon/da-fea_icon02.svg'
import icon3 from '../../../images/icon/da-fea_icon03.svg'
import icon4 from '../../../images/icon/da-fea_icon04.svg'

import hicon from '../../../images/icon/flower-icon-blue.svg'

const Features = [
    {
        title: 'Mobile Apps',
        des: 'iOS & Android — native and cross-platform.',
        icon: icon1,
        col: 'col-lg-3 col-md-6 fea-col',
    },
    {
        title: 'Backend',
        des: 'APIs, microservices, and cloud infrastructure at scale.',
        icon: icon2,
        col: 'col-lg-3 col-md-6 fea-col',
    },
    {
        title: 'Web Apps',
        des: 'Consumer products, dashboards, and internal tooling.',
        icon: icon3,
        col: 'col-lg-3 col-md-6 fea-col',
    },
    {
        title: 'AI',
        des: 'LLM integration, voice pipelines, and intelligent automation.',
        icon: icon4,
        col: 'col-lg-3 col-md-6 fea-col',
    },

]


const FeatureSection = (props) => {

    const ClickHandler = (e) => {
        if (e) e.preventDefault();
    }
    return (
        <section className="feature pt-150 pb-150" style={{ backgroundColor: '#F8F8F7' }}>
            <div className='container-fluid p-0'>
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-lg-8">
                        <div className="da-sec-titlte text-center mb-70">
                            <span className="sub_title"><span><img src={hicon} alt="" /></span>What we do</span>
                            <h2 className="title">Mobile apps, backend systems, web products, and AI — built for teams that think differently.</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">

                <div className="da-feature-wrap">
                    <div className="row g-0">
                        {Features.map((features, fitem) => (
                            <div className={features.col} key={fitem}>
                                <div className="da-feature-item">
                                    <div className="xb-item--holder">
                                        <div className="xb-item--icon"><img src={features.icon} alt="" /></div>
                                        <h3 className="xb-item--title">{features.title}</h3>
                                        <p className="xb-item--content">{features.des}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="xb-btn text-center mt-70">
                    <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--fill_icon thm-btn--data thm-btn--data_blue">
                        <div className="xb-item--hidden"><span className="xb-item--hidden-text">Start a conversation</span></div>
                        <div className="xb-item--holder">
                            <span className="xb-item--text xb-item--text1">Start a conversation</span>
                            <div className="xb-item--icon"><i className="fal fa-plus"></i></div>
                            <span className="xb-item--text xb-item--text2">Start a conversation</span>
                        </div>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default FeatureSection;